(function () {
	var timer = null;

	function unlock(node) {
		node.classList.remove('release-at-pending');
		node.querySelectorAll('[data-release-locked]').forEach(function (element) {
			element.disabled = element.hasAttribute('data-unavailable');
			element.classList.remove('product-form__submit--coming-soon');
			if (!element.disabled) element.removeAttribute('aria-disabled');

			var addLabel = element.getAttribute('data-add-label');
			var label = element.querySelector('span');
			if (addLabel && label && !element.hasAttribute('data-unavailable')) {
				label.textContent = addLabel;
			}
		});

		var label = node.querySelector('[data-release-label]');
		var form = node.querySelector('[data-release-form]');
		if (label) label.hidden = true;
		if (form) form.hidden = false;
	}

	function tick() {
		if (timer) window.clearTimeout(timer);

		var now = Math.floor(Date.now() / 1000);
		var next = null;

		document.querySelectorAll('[data-release-at]').forEach(function (node) {
			var at = Number(node.getAttribute('data-release-at'));
			if (!at) return;

			if (now >= at) {
				unlock(node);
				return;
			}

			if (next === null || at < next) next = at;
		});

		if (next === null) return;

		var wait = Math.min((next - now) * 1000, 2147483647);
		timer = window.setTimeout(tick, Math.max(wait, 1000));
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', tick);
	} else {
		tick();
	}

	document.addEventListener('release-at:refresh', tick);
})();
